
import React from "react";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import {Collapse} from "antd";
import MagazineColData from "../Data/MagazineColData"
import GlamImagesData from "../Data/GlamImagesData";

const GlamStyle = () => {

  return (
    <section className="aa-ph-container pt-[70px] sm:pt-[100px] px-4 sm:px-2 lg:px-0">
      <h2 className="text-center text-[32px] sm:text-[60px] md:text-[120px] lg:text-[160px] leading-[38px] sm:leading-[70px] md:leading-[125px] lg:leading-[200px]">
      GLAM STYLE
      </h2>
      <div className="w-[90%] mx-auto grid grid-cols-2 sm:grid-cols-4 gap-6">
        { GlamImagesData?.map((image, ind) => (
            <img key={ind} src={image?.imgSrc} alt="photo-booth-magazine" className="w-full h-auto" /> 
        ))}
        
      </div>
      <div className="mx-auto w-full sm:max-w-[1200px] pt-[50px] flex flex-col sm:flex-row gap-6 sm:gap-0 items-start">
        <div className="w-full sm:w-1/2 pr-0 sm:pr-[80px]">
          <h4 className="text-[18px] sm:text-[24px] leading-[24px] sm:leading-[32px] font-poppins-regular">
          Glam Style provides a sophisticated black and white theme for elegant events, enhancing photo sessions with classy vibes for lasting memories. Upgrade your Photo Booth Experience.
          </h4>
          <button className="mt-8 uppercase font-poppins-regular text-[#fff] text-[14px] sm:text-[16px] bg-[#000] px-[14px] sm:px-[32px] py-[8px] sm:py-[16px] rounded-[40px] ">
          DISCOVER GLAM STYLE
          </button>
        </div>
        <div className="w-full sm:w-1/2">
          <Collapse
            bordered={false}
            expandIcon={({ isActive }) => ( <> { isActive ? <MinusOutlined /> : <PlusOutlined /> } </>)}
            expandIconPosition="end"
            items={MagazineColData}
          />
        </div>
      </div>
    </section>
  );
};

export default GlamStyle;


